<template>
    <ds-modal
        :is-open="isOpen"
        show-close
        size="med"
        title="Review issues"
        class="content-risk-modal"
        @close="$emit('close')"
    >
        <template #title>
            <h4>
                <strong class="modal-title">
                    Review issues
                </strong>
            </h4>
        </template>

        <h3 class="spam-issues-found-text">
            {{ messages.length > 1
                ? `${messages.length} spam issues found in your email`
                : `${messages.length} spam issue found in your email` }}
        </h3>

        <content-risk-messages
            :quality="quality"
            :messages="messages"
            class="content-risk-messages"
        >
            <strong class="issues-text-bold">
                {{ strongRecommendationText }}
            </strong>

            <span>{{ recommendationText }}</span>
        </content-risk-messages>

        <div class="buttons-container">
            <ds-filled-button
                aria-label="Go back and fix issues"
                class="button-fix-issues"
                data-qa="go-back-and-fix-issues-button"
                @click="$emit('close')"
            >
                Go back and fix issues
            </ds-filled-button>

            <ds-text-button
                v-if="sendable"
                aria-label="Continue to send"
                class="button-continue-to-send"
                data-qa="continue-to-send-button"
                @click="$emit('continue-to-send')"
            >
                Continue to send
            </ds-text-button>
        </div>
    </ds-modal>
</template>

<script>
import ContentRiskMessages from './ContentRiskMessages';
import { CONTENT_RISK_QUALITY } from './content-risk.constants';

export default {
    name: 'ContentRiskModal',

    components: {
        ContentRiskMessages,
    },

    props: {
        quality: String,
        messages: {
            type: Array,
            default: () => [],
        },

        sendable: Boolean,
        isOpen: Boolean,
    },

    computed: {
        strongRecommendationText() {
            const issues = this.messages.length > 1 ? 'issues' : 'issue';
            const type = this.quality === CONTENT_RISK_QUALITY.SPAM_NOT_SENDABLE
                ? 'high risk'
                : 'moderate risk';

            return `${this.messages.length} ${type} ${issues}`;
        },

        recommendationText() {
            return this.quality === CONTENT_RISK_QUALITY.SPAM_NOT_SENDABLE
                ? 'must be fixed before sending:'
                : 'we recommend you fix:';
        },
    },
};
</script>

<style lang="scss" scoped>
.content-risk-modal {
    // TODO: make the modal-body-inner scrollable in Design System (if approved)
    //   Related task: https://jira.infusionsoft.com/browse/EO-3311
    --modal-overflow: visible;
    --modal-padding: #{$spacing-200 $spacing-300 $spacing-300 $spacing-300};
}

.content-risk-messages {
    margin-bottom: $spacing-200;
}

.spam-issues-found-text {
    font-size: $font-size-md;
    font-weight: $font-weight-bold;
    margin-bottom: $spacing-200;
}

.buttons-container {
    display: flex;
}

.button-fix-issues {
    @include margin-end($spacing-200);
}
</style>
